
export const statusReasonInfo: IEntities = [
    { id: 'A0', description: 'First time activation' },
    { id: 'A1', description: 'Resumed from Suspended status' },
    { id: 'A3', description: 'Activated by admin' },
    { id: 'S0', description: 'Temporary suspension: initiated by the user or system user or the system' },
    { id: 'S4', description: 'Suspended by Admin' },
    { id: 'T0', description: 'Card is lost' },
    { id: 'T1', description: 'Card is stolen' },
    { id: 'T2', description: 'Card is expired' },
    { id: 'T3', description: 'Card is damaged' },
    { id: 'T4', description: 'Card is closed by user' },
    { id: 'T5', description: 'Card is closed by issuer' },
];

export interface IEntity {
    id: string;
    description: string;
}

export type IEntities = IEntity[];